"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginTestUsersBodyToJSON = exports.LoginTestUsersBodyFromJSONTyped = exports.LoginTestUsersBodyFromJSON = void 0;
function LoginTestUsersBodyFromJSON(json) {
    return LoginTestUsersBodyFromJSONTyped(json, false);
}
exports.LoginTestUsersBodyFromJSON = LoginTestUsersBodyFromJSON;
function LoginTestUsersBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userIds': json['userIds'],
    };
}
exports.LoginTestUsersBodyFromJSONTyped = LoginTestUsersBodyFromJSONTyped;
function LoginTestUsersBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userIds': value.userIds,
    };
}
exports.LoginTestUsersBodyToJSON = LoginTestUsersBodyToJSON;
